/* ============================================================
   CiemnaSzyba — karuzela realizacji (coverflow)
   Źródło: linie 1098–1113. Geometria przeniesiona 1:1
   (step 250px, scale = max(0.55, 1 - |off| * 0.13), z-index 30 - |off|,
   karty dalej niż 3 pozycje znikają).

   Różnica: w Design cały atrybut style był jedną zmienną {{ c.style }}.
   Tu statyka siedzi w CSS, a JS ustawia tylko trzy custom properties.
   Doszła też obsługa klawiatury i swipe, których źródło nie miało.
   ============================================================ */
(function () {
  "use strict";

  var STEP = 250;

  CS.onSection("[data-cs-realizacje]", function (root) {
    var slides = CS.$$("[data-cs-slide]", root);
    var counter = root.querySelector("[data-cs-real-current]");
    var stage = root.querySelector("[data-cs-stage]");
    if (!slides.length || !stage) return;

    var idx = 0;
    var n = slides.length;

    function render() {
      slides.forEach(function (el, i) {
        var off = i - idx;
        if (off > n / 2) off -= n;
        else if (off < -n / 2) off += n;
        var abs = Math.abs(off);

        el.style.setProperty("--off", off);
        el.style.setProperty("--scale", Math.max(0.55, 1 - abs * 0.13));
        el.style.setProperty("--z", 30 - abs);
        el.classList.toggle("is-far", abs > 3);
        el.classList.toggle("is-current", off === 0);
      });
      if (counter) counter.textContent = idx + 1;
    }

    function go(delta) {
      idx = (idx + delta + n) % n;
      render();
    }

    function onClick(e) {
      var btn = e.target.closest("[data-cs-real]");
      if (!btn || !root.contains(btn)) return;
      go(btn.getAttribute("data-cs-real") === "next" ? 1 : -1);
    }

    function onKey(e) {
      if (e.key === "ArrowLeft") go(-1);
      else if (e.key === "ArrowRight") go(1);
    }

    var startX = null;
    function onStart(e) { startX = e.touches ? e.touches[0].clientX : null; }
    function onEnd(e) {
      if (startX === null) return;
      var dx = e.changedTouches[0].clientX - startX;
      if (Math.abs(dx) > 40) go(dx < 0 ? 1 : -1);
      startX = null;
    }

    root.addEventListener("click", onClick);
    stage.addEventListener("keydown", onKey);
    stage.addEventListener("touchstart", onStart, { passive: true });
    stage.addEventListener("touchend", onEnd, { passive: true });
    stage.setAttribute("tabindex", "0");
    stage.style.setProperty("--step", STEP + "px");

    render();

    return function () {
      root.removeEventListener("click", onClick);
      stage.removeEventListener("keydown", onKey);
      stage.removeEventListener("touchstart", onStart);
      stage.removeEventListener("touchend", onEnd);
    };
  });
})();
